import { render, staticRenderFns } from "./SchoolRates.vue?vue&type=template&id=0388c136&scoped=true"
import script from "./SchoolRates.vue?vue&type=script&lang=js"
export * from "./SchoolRates.vue?vue&type=script&lang=js"
import style0 from "./SchoolRates.vue?vue&type=style&index=0&id=0388c136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0388c136",
  null
  
)

export default component.exports